"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_redux_1 = require("react-redux");

var pharmacy_pricing_reducer_actions_1 = require("../../../experiences/pharmacy-pricing-experience/store/pharmacy-pricing/pharmacy-pricing-reducer.actions");

var selector_1 = require("./selector");

var changeOffsetTypePropertyAction = pharmacy_pricing_reducer_actions_1.pricingRuleDetailsSetSelectorPropertyActionBuilder('offsetType');
var selectorActionProps = {
  onChangeItem: changeOffsetTypePropertyAction
};

exports.mapStateToProps = function (state) {
  return __assign(__assign(__assign({}, state), selectorActionProps), {
    selectorId: 'offsetType',
    selectorItemList: [{
      label: 'AWP',
      id: 'AWP'
    }, {
      label: 'NADAC',
      id: 'NADAC'
    }],
    selectorLabel: 'Offset Type'
  });
};

var actions = selectorActionProps;
exports.ConnectedOffsetSelector = react_redux_1.connect(exports.mapStateToProps, actions)(selector_1.Selector);